<template>
  <div class="app-forgot-password-channel content-limiter">
    <dyn-slot :slot-data="slotData">
      <slot name="msisdn">
        Dein Passwort wird automatisch zurückgesetzt. Du erhältst einen SMS-Code an oder einen Link an Deine hinterlegte
        E-Mail-Adresse.
      </slot>
    </dyn-slot>
    <form>
      <div class="inputs-container">
        <div class="radio-group flex-column">
          <label>
            <input type="radio" name="channelLocal" value="email" v-model="channelLocal" />
            <span class="custom-radio"></span>
            <span class="text-base">E-Mail anfordern</span>
          </label>
          <label>
            <input type="radio" name="channelLocal" value="sms" v-model="channelLocal" />
            <span class="custom-radio"></span>
            <span class="text-base">SMS anfordern</span>
          </label>
        </div>
        <span v-if="$v.channelLocal.$error" class="text-sm text-error">
          Wähle bitte eine Option aus
        </span>
      </div>
      <Stepper :show-prev="false" @next="validateAndSave()">
        <template #btnNext><slot name="btnNext">Weiter</slot></template>
      </Stepper>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import preFilledInput from '../../../../../mixins/preFilledInput'
import isValid from '../../../../../mixins/isValid'
import Stepper from '@/components-v2/generic/Stepper.vue'

export default {
  name: 'ForgotPasswordChannel',
  mixins: [preFilledInput('channelLocal', 'channel'), validationMixin, isValid],
  data() {
    return {
      loading: false
    }
  },
  computed: {
    slotData() {
      return {
        msisdn: this.msisdn,
        loading: this.loading
      }
    },
    ...mapGetters('forgotPassword', ['msisdn', 'channel'])
  },
  components: { Stepper },
  methods: {
    ...mapMutations('forgotPassword', ['recaptureMsisdn']),
    ...mapActions('forgotPassword', ['performResetChannel']),
    validateAndSave() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.save()
    },
    save() {
      this.loading = true
      this.performResetChannel(this.channelLocal).then(
        () => {
          this.loading = false
        },
        e => {
          this.loading = false
        }
      )
    }
  },
  validations: {
    channelLocal: {
      required
    }
  }
}
</script>
